import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "sonner";
import api from "../../lib/api";

/** Accept / Decline buttons for a pending Studio collaboration invite. */
export const InviteActions = ({ projectId, inviteId, status = "pending", onDone, compact }) => {
  const [busy, setBusy] = useState(false);
  const [state, setState] = useState(status || "pending");
  const navigate = useNavigate();

  const respond = async (e, decision) => {
    e.stopPropagation();
    setBusy(true);
    try {
      await api.post(`/studio/projects/${projectId}/collaborators/respond`, { decision });
      setState(decision);
      toast.success(decision === "accepted" ? "Invite accepted — session added to your Studio" : "Invite declined");
      onDone?.(decision);
    } catch (err) {
      toast.error(err?.response?.data?.detail || "This invite is no longer available");
      setState("expired");
    } finally {
      setBusy(false);
    }
  };

  if (state === "accepted") {
    return (
      <button type="button" onClick={(e) => { e.stopPropagation(); navigate(`/studio/session/${projectId}`); }}
        className="mt-2 h-8 px-3 rounded-full bg-fuchsia-600 text-white text-xs font-bold active:scale-95 transition-transform"
        data-testid={`invite-open-${inviteId}`}>Open session</button>
    );
  }
  if (state !== "pending") {
    return <p className="mt-2 text-xs text-gray-400" data-testid={`invite-status-${inviteId}`}>Invite {state}</p>;
  }
  return (
    <div className={`flex gap-2 ${compact ? "" : "mt-2"}`}>
      <button type="button" disabled={busy} onClick={(e) => respond(e, "accepted")}
        className="h-8 px-4 rounded-full bg-emerald-500 text-black text-xs font-black disabled:opacity-50 active:scale-95 transition-transform"
        data-testid={`invite-accept-${inviteId}`}>Accept</button>
      <button type="button" disabled={busy} onClick={(e) => respond(e, "declined")}
        className="h-8 px-4 rounded-full border border-white/20 text-gray-200 text-xs font-bold disabled:opacity-50 active:scale-95 transition-transform"
        data-testid={`invite-decline-${inviteId}`}>Decline</button>
    </div>
  );
};

export default InviteActions;
